<template>
    <div class="index-wrap index-wrapabout" style="background:none">
      <div class="index-menu menuBg">
        <div class="header-main">
          <div class="menu">
            <a class="logo" href="javascript:;">
              <img src="../../public/assets/img/logo.png">
            </a>
            <div class="menu_left">
              <router-link to="/" exact active-class="active" class="anchor-link">首页</router-link>
              <router-link :to="{ name: 'ServiceList' }" class="anchor-link">服务列表</router-link>
              <router-link :to="{ name: 'PayMent' }" class="anchor-link">付费方式</router-link>
              <router-link :to="{ name: 'IntroduceAbout' }" class="anchor-link">关于我们</router-link>
            </div>
            <div class="phone">
              19567978183
            </div>
            <div class="info">
              <!-- {{ user }} -->
              <div v-if="user">
                <a href="https://vip.zhaobiaoguancha.cn/user/index" style="color:white">会员中心</a>
                <div class="user-info" style="display:none">
                  <div class="header-usermenu">
                    <a href="javascript:;" class="header-title show_nickname">{{ user.username }}</a>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="loginReg">
                  <a class="reg" href="https://vip.zhaobiaoguancha.cn/user/login?tab=register">注册</a>
                  <a class="login" href="https://vip.zhaobiaoguancha.cn/user/login?tab=login">登录</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about-article">
        <h1>中 国 采 购 网 竭 诚 服 务</h1>
        <p>
          中国采购网（
          <a href="http://www.zg-cgw.cn/">www.zg-cgw.cn</a>
          ）在有关部门和权威专家的指导下，致力于为企业提供招标、采购、拟在建项目信息及网上招标采购等一系列商务服务。中国采购网是中国招标采购领域的资讯和交易网站，为各级政府采购、招标代理机构、招标企业、供应商提供强大的专业招标采购信息查询和相关服务。
        </p>
        <p>
          中国采购网以帮助企业敏锐掌握市场动向、迅速获得市场商机为宗旨，借助丰富的政府资源，全面收集国内市场经济环境、国内政策环境及国际贸易环境的变化信息，在激烈的市场竞争中发掘新的市场机会，监视竞争对手及潜在的竞争对手，做到"知己知彼，百战不怠"，为企业建立自己的竞争情报信息系统提供平台和信息资源。
        </p>
        <p>1. <span>准确性和权威性：</span></p>
        <p class="indexTendent">
          以跨部委的政府资源为基础，与众多的招标公司和业主单位建立坚实的合作，获取全面和准确的招标、采购及项目信息。
        </p>
        <p>2. <span>丰富的信息数量：</span></p>
        <p class="indexTendent">
          每天信息更新总量超过70000条，招标公告每天更新超过35000条，中标公告每天更新超过25000条，行业资讯每天更新超过3000条，变更公告每天更新超过5000条，拟在建项目每天更新超过500条，招标预告每天更新超过500条，VIP独家项目每天更新超过100条。
        </p>
        <p>3. <span>信息快捷和准确：</span></p>
        <p class="indexTendent">
          项目规划、拟在建项目、招标预告与招标公告相结合，企业提高把握项目的能力和提前调配资源时间。
        </p>
        <p>4. <span>广泛的信息覆盖面：</span></p>
        <p class="indexTendent">
          全面覆盖1000多个行业及大陆所有地区。
        </p>
        <p>5. <span>强大的技术力量与专业的团队：</span></p>
        <p class="indexTendent">
          中国采购网拥有包括信息收集、整理、发布的一系列技术解决方案，可以为客户提供稳定可靠的服务。中国采购网主要人员都有招标相关的工作经历，中国采购网的专家库覆盖60多个行业，有超过26000名专家承担并主管过多项国家重点的能源、交通、高速公路油田、技改项目。
        </p>
      </div>
      <div class="footer">
        <p class="copyright">
          © 2017-2025 招标采购网 All Rights Reserved. Power By 京源
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        user: false, // 登录状态，可以通过 Vuex 或其他状态管理替代
        cdnPath: "__CDN__", // 静态资源路径
        userCenterUrl: "/user/index", // 用户中心路径
      };
    },
  };
  </script>
  